import React, {useContext, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import General from "./General/General.tsx";
import ConfirmationPopup from "./Subcomponents/ConfirmationPopup/ConfirmationPopup.tsx";
import Customization from "./Customization/Customization.tsx";
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";
import {clearChatHistory} from "../../../../Utils/db/chatHistory/chatMetadataUtils.ts";
import {GlobalContext} from "../../../../App.tsx";
import ManageAccount from "./ManageAccount/ManageAccount.tsx";
import Feedback from "./Feedback/Feedback.tsx";
import Ide from "./Environment/Ide/Ide.tsx";
import Tools from "./Tools/Tools.tsx";

interface SettingsDetailProps {
    activeTab: string;
    onBackClick: () => void;
}

const SettingsDetail: React.FC<SettingsDetailProps> = ({ activeTab, onBackClick }) => {
    const { resetStateHelper } = useContext(GlobalContext);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { isIncognito } = settingsObj;
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleConfirmClear = () => {
        clearChatHistory(isIncognito, user, setDynamicStateObj, resetStateHelper);
        setShowConfirmation(false);
    };

    return (
        <div className="flex flex-col h-full">
            <div className="flex justify-between items-center p-4 border-b border-neutral-600/30">
                <button
                    className="dark:text-neutral-300 dark:hover:text-neutral-100 transition-colors duration-200"
                    onClick={onBackClick}
                >
                    <FontAwesomeIcon icon={faArrowLeft} className="h-5 w-5" />
                </button>
                <h2 className="text-lg font-semibold dark:text-neutral-100">
                    {activeTab}
                </h2>
                <div />
            </div>
            <div className="flex-1 p-4 overflow-y-auto">
                {activeTab === 'General' && (
                    <General
                        setShowConfirmation={setShowConfirmation}
                    />
                )}
                {activeTab === 'Tools' && (
                    <Tools />
                )}
                {activeTab === 'Customization' && (
                    <Customization />
                )}
                {activeTab === 'Manage Account' && (
                    <ManageAccount />
                )}
                {activeTab === 'IDE' && (
                    <Ide/>
                )}

                {activeTab === 'Feedback' && (
                    <Feedback />
                )}
            </div>
            {showConfirmation && (
                <ConfirmationPopup
                    message="Are you sure you want to clear all chat history? This action cannot be undone."
                    onConfirm={handleConfirmClear}
                    onCancel={() => setShowConfirmation(false)}
                />
            )}
        </div>
    );
};

export default SettingsDetail;